module.exports = __webpack_public_path__ + "static/media/29.5d8fd9f8.jpg";